import { useCallback, useReducer } from 'react';
import { getWordCount, sha256Hash } from './utils';
const defaultAnalyticsContextState = {
  queryVersion: 0,
  isLoading: false
};
const analyticsContextReducer = (state, action) => {
  switch (action.type) {
    case 'queryVersion':
      return {
        ...state,
        queryVersion: action.value
      };
    case 'isLoading':
      return {
        ...state,
        isLoading: action.value
      };
    case 'reset':
      return defaultAnalyticsContextState;
    default:
      throw new Error();
  }
};
export const useAnalyticsContext = query => {
  const [{
    queryVersion,
    isLoading
  }, setAdditionalAnalyticsContext] = useReducer(analyticsContextReducer, defaultAnalyticsContextState);
  const addAnalyticContext = useCallback(() => {
    return {
      wordCount: getWordCount(query),
      queryLength: query.length,
      queryHash: sha256Hash(query),
      queryHashSHA256: sha256Hash(query),
      queryVersion: queryVersion
    };
  }, [query, queryVersion]);
  const nonPrivacySafeContext = useCallback(() => {
    return {
      query
    };
  }, [query]);
  return {
    isLoading,
    setAdditionalAnalyticsContext,
    addAnalyticContext,
    nonPrivacySafeContext,
    queryVersion
  };
};